var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"devices"}},[_c('v-row',[_c('v-col',{staticClass:"custom-card px-0 pa-0"},[_c('DataTable',{attrs:{"settings":_vm.settings,"columns":_vm.columns,"rows":_vm.rows,"totalRows":10},on:{"onFilter":_vm.getRows}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }